import React, { useState } from 'react';

import { Badge } from 'antd';

import { dateMomentFormat } from 'v2/formatters/date';
import type { INotification } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

const ListItemNotification = ({ notification }: { notification: INotification }) => {
  const currentNotification = notificationService.formatNotification(notification);

  const [readed, setReaded] = useState<boolean>(currentNotification.readed);

  const formatedCreateAt = dateMomentFormat(
    new Date(currentNotification.createdAt as string | number | Date),
    'DD/MM/yyyy - HH:mm'
  );

  return (
    <a target='_blank' rel='noopener noreferrer' href={currentNotification.redirect} onClick={() => setReaded(true)}>
      <div className='text-text-heading hover:bg-grey-50 flex items-center gap-3 border-b border-[#f0f0f0] bg-white px-4 py-3 transition-colors'>
        <Badge count={readed ? 0 : 1} dot offset={[-2, 2]}>
          <div
            className='flex h-9 w-9 shrink-0 items-center justify-center rounded-full'
            style={{ backgroundColor: currentNotification.color }}
          >
            <span className='material-icons text-lg leading-none text-black'>{currentNotification.icon}</span>
          </div>
        </Badge>
        <div className='min-w-0 flex-1'>
          <div className='text-sm font-medium'>{currentNotification.title}</div>
          <div className='truncate text-[13px] text-gray-500'>{currentNotification.message}</div>
        </div>
        <div className='shrink-0 text-xs whitespace-nowrap text-gray-400'>{formatedCreateAt}</div>
      </div>
    </a>
  );
};
export default ListItemNotification;
